import { useMemo } from 'react';
import { InfoBanner } from '@ui';
import { useLogisticsData } from '@lp/features/RoutePlanner/hooks/useLogisticsProjection';
import { checkResourceOnActiveGroundTrip } from '@lp/features/RoutePlanner/utils';

type ActiveGroundTripWarningProps = {
  resourceId?: string;
};

export const ActiveGroundTripWarning = ({ resourceId }: ActiveGroundTripWarningProps) => {
  const { groundTripIds } = useLogisticsData();

  const isActiveGroundTrip = useMemo(() => {
    return checkResourceOnActiveGroundTrip(groundTripIds, resourceId);
  }, [resourceId, groundTripIds]);

  if (!isActiveGroundTrip) return null;

  return (
    <InfoBanner iconType="warning">
      The trips linked to the affected ground legs are already In Progress, Completed, or Canceled status.
    </InfoBanner>
  );
};
